import React from 'react';
import { Icon } from '../Icon';
import loadingGif from '../../assets/icons/tmr_loader.gif';
import './LoadingIndicator.scss';
export const LoadingIndicator = ({ loadingText = 'Loading, please wait...', height = 'auto', }) => (React.createElement("div", { style: { height }, className: "loading-indicator-wrapper" },
    React.createElement(Icon, { source: loadingGif, className: "loading-indicator", altText: loadingText }),
    React.createElement("div", { className: "loading-text" }, loadingText)));
//# sourceMappingURL=LoadingIndicator.js.map